import { Config } from "@/shared/config";

const deductibleTrackerServiceUri = Config.DeductibleTrackerServicebaseUri;

export default {
  get deductibleTrackerV1 () {
    return `${deductibleTrackerServiceUri}/deductibletracker/v1`;
  },
  getGenerateMymedicalshopperUrl (): string {
    return `${this.deductibleTrackerV1}/account/generate-mymedicalshopper-url`;
  },
  getTalonEnabledForUser (): string {
    return `${this.deductibleTrackerV1}/account/talon-enabled-for-user`;
  },
  isTalonEnabledForUser (username: string) {
    return `${this.deductibleTrackerV1}/account/${username}/is-talon-enabled-for-user`;
  },
  getHealthPlanIsLinked (): string {
    return `${this.deductibleTrackerV1}/healthplan/is-linked`;
  },
  getHealthPlans (): string {
    return `${this.deductibleTrackerV1}/healthplan/plans`;
  }
};